import "../styles/font/font.css";

const theme = {
  black: "#000000",
  white: "#FFFFFF",
  lightGrey: "#e6e6e6",
  middleGrey: "#aaaaaa",
  darkGrey: "#6f6f6f",
  deepGray: "#3d3d3d",
  skyBlue: "#c6e1f4",
  blue: "#3294EA",
  darkBlue: "#144571",
  red: "#F11A26",
  pink: "#F8DAE2",
  yellow: "#F7EDBA",
  mint: "#B3EBE2",
  borderRadius: "20px",

  yangjin: "양진체",
  yeonsung: "BMYEONSUNG",

  micro: "35px",
  small: "40px",
  middle: "50px",
  large: "60px",
  xlarge: "170px",

  border3: "3px solid #000000",
  border5: "5px solid #000000",
  border10: "10px solid #000000",
};

export default theme;
